// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST,
    ACTIVITIES_GET_USERS_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    activitiesSearchActivitiesLogsResult,
    activitiesSearchUsersResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchAuditlogs({ payload }) {
    try {
        let QUERY = `
            query searchAuditlogs ($accountId: String, $entity: EntityAuditLogInput, $action: [String], $opensearch: [String], $username: String, $dateRange: AWSDateTimeRange!, $nextToken: String, $lastRecords: Int) {
                result: searchAuditlogs (accountId: $accountId, entity: $entity, action: $action, opensearch: $opensearch, username: $username, dateRange: $dateRange, nextToken: $nextToken, lastRecords: $lastRecords) {
                    items {
                        id
                        source
                        urlReferrer
                        module
                        method
                        ipAddress
                        platform
                        entityName
                        entityId
                        accountId
                        action
                        newValues
                        parameters
                        updatedBy
                        updatedOn
                        username
                    }
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(activitiesSearchActivitiesLogsResult({ activities: data?.result?.items, nextToken: data?.result?.nextToken, oldNextToken: payload?.nextToken }))
        }
    } catch (exc) {
        yield put(activitiesSearchActivitiesLogsResult({ error: true }));
        //ExceptionManager(exc, 'Modules/activities/views/main/redux/saga', 'searchAuditlogs');
    }
}

function* searchUsers({ payload }) {
    try {
        let QUERY = `
        query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
            result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    userName
                    email
                }
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: [
                        "companyId"
                    ],
                    terms: [
                        payload
                    ],
                    exact: true
                },
                "sort": {
                    "field": "userName",
                    "order": "ASC"
                },
                limit: 400,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(activitiesSearchUsersResult({ users: data?.result?.items }))
        }

    } catch (exc) {
        yield put(activitiesSearchUsersResult({ error: true }))
        ExceptionManager(exc, 'Modules/activities/views/main/redux/saga', 'searchUsers');
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    hasPromiles
                    timezoneId
                    timezone
                    username
                    integrations {
                        integrationId
                        parameters
                        status
                    }
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/views/main/redux/saga', 'getAccounts');
    }
}

function* watchMethods() {
    yield takeEvery(ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST, searchAuditlogs);
    yield takeEvery(ACTIVITIES_GET_USERS_REQUEST, searchUsers);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}